import { render, staticRenderFns } from "./best-pick-pill.vue?vue&type=template&id=6486a022&scoped=true"
import script from "./best-pick-pill.vue?vue&type=script&lang=js"
export * from "./best-pick-pill.vue?vue&type=script&lang=js"
import style0 from "./best-pick-pill.vue?vue&type=style&index=0&id=6486a022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486a022",
  null
  
)

export default component.exports